import { Platform } from 'react-native';
import { CloudinaryResourceType } from '@/shared/types';

export const IS_WEB = Platform.OS === 'web';

export const ALLOWED_MIME_TYPES: Record<CloudinaryResourceType, string[]> = {
  image: [
    'image/jpeg', // covers jpg & jpeg
    'image/png',
    'image/gif',
  ],
  video: [
    // Placeholder mimetypes for video files
    'video/mp4',
    'video/quicktime', // .mov files
  ],
  raw: [
    // Placeholder mimetypes for raw files
    'application/pdf',
  ],
};

export const CLOUDINARY_IMAGE_MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const NAME_MAX_LENGTH = 50;
export const BIO_MAX_LENGTH = 300;
export const HANDLE_MAX_LENGTH = 30;

export const PHONE_NUMBER_MASK = [
  '(',
  /\d/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const EMME_SUPPORT_EMAIL = 'support@emmestyling.com';
export const EMME_APP_STORE_URL =
  'https://apps.apple.com/us/app/emme-styling/id6742431174';
export const EMME_EVENT_LANDING =
  'https://www.emmestyling.com/not-a-normal-show';
/** Web app URL for Set Availability (mobile app redirects here) */
export const EMME_WEB_AVAILABILITY_URL =
  'https://www.emmestyling.com/availability';
